import React from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn-lite';

import './TranslateDemoArrows.scss';

const b = block('TranslateDemoArrows');

function Arrows(props) {
    return (
        <div className={b()} onClick={props.handleExchange}>
            <div className={b('arrow')} />
            <div className={b('arrow')} />
        </div>
    );
}

Arrows.propTypes = {
    handleExchange: PropTypes.func,
};

export default Arrows;
